import React, { useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { CategoriesFilter } from "./categories-filter/CategoriesFilter";
import { CategoriesTable } from "./categories-table/CategoriesTable";
import { CategoriesGrouping } from "./categories-grouping/CategoriesGrouping";
import { useCategoriesUIContext } from "./CategoriesUIContext";
import * as actions from "../../_redux/categories/categoriesActions";
import { AddCategoryModal } from "./AddCategoryModal";

export function CategoriesCard() {
  const {user} = useSelector(state => state.auth);
  const userobject = user.userData;
  var superadmin = true;
  if (userobject.admin_role && userobject.admin_role !== 'superadmin' && userobject.is_admin) { superadmin = false; }
 
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  
  let tab = "all";
  const pathParts = location.pathname.split("/");
  if (pathParts[2] === "approved" || pathParts[2] === "pending" || pathParts[2] === "rejected") {
    tab = pathParts[2];
  }

  const callFilterFunction = (val) => {
    if(val==="all")       { navigate(`/category/`); }
    if(val==="approved")  { navigate(`/category/approved`); }
    if(val==="pending")   { navigate(`/category/pending`); }
    if(val==="rejected")  { navigate(`/category/rejected`); }
  };

  const categoriesUIContext = useCategoriesUIContext();
  const [showcreatemodal, showCreateModal] = useState(false);

  const categoriesUIProps = useMemo(() => {
    return {
      ids: categoriesUIContext.ids,
      queryParams: categoriesUIContext.queryParams,
      setQueryParams: categoriesUIContext.setQueryParams,
      newCategoryButtonClick: categoriesUIContext.newCategoryButtonClick,
      openDeleteCategoriesDialog: categoriesUIContext.openDeleteCategoriesDialog,
      openEditCategoryPage: categoriesUIContext.openEditCategoryPage,
      openUpdateCategoriesStatusDialog:
        categoriesUIContext.openUpdateCategoriesStatusDialog,
      openFetchCategoriesDialog: categoriesUIContext.openFetchCategoriesDialog,
    };
  }, [categoriesUIContext]);

  return (
    <Card>
      <AddCategoryModal
        show={showcreatemodal}
        onHide={() => showCreateModal(false)}
        mode="category"
        onCategoryCreated={() => {
          dispatch(actions.fetchCategories(categoriesUIProps.queryParams));
        }}
      />
      <CardHeader title="Category List">
        <CardHeaderToolbar>
        {
         (superadmin)? <button type="button" className="btn btn-primary" onClick={() => showCreateModal(true)}> New Category </button>:<></>
        }
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <CategoriesFilter />
        {categoriesUIProps.ids.length > 0 && superadmin && (
          <>
            <CategoriesGrouping />
          </>
        )}
        <ul className="nav nav-tabs nav-tabs-line mb-3" role="tablist">
          <li className="nav-item" onClick={() => callFilterFunction("all")}>
            <a
              href
              className={`nav-link ${tab === "all" && "active"}`}
              data-toggle="tab"
              role="tab"
              aria-selected={(tab === "all").toString()}
            >
              All 
            </a>
          </li>
          <li className="nav-item" onClick={() => callFilterFunction("approved")}>
            <a
              href
              className={`nav-link ${tab === "approved" && "active"}`}
              data-toggle="tab"
              role="tab"
              aria-selected={(tab === "approved").toString()}
            >
              Approved 
            </a>
          </li>
          <li className="nav-item" onClick={() => callFilterFunction("pending")}>
            <a
              href
              className={`nav-link ${tab === "pending" && "active"}`}
              data-toggle="tab"
              role="tab"
              aria-selected={(tab === "pending").toString()}
            >
              Pending
            </a>
          </li>
          <li className="nav-item" onClick={() => callFilterFunction("rejected")}>
            <a
              href
              className={`nav-link ${tab === "rejected" && "active"}`}
              data-toggle="tab"
              role="tab"
              aria-selected={(tab === "rejected").toString()}
            >
              Rejected
            </a>
          </li>
        </ul>
        <CategoriesTable />
      </CardBody>
    </Card>
  );
}
